import React from 'react';
import colors from '../ColorConfig/colorconfig';

const { primary } = colors;

const BackgroundElements = ({ isVisible }) => {
  return (
    <>
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '60px',
        height: '60px',
        backgroundColor: primary,
        borderRadius: '50%',
        opacity: isVisible ? 0.1 : 0,
        transition: 'opacity 1s ease-in-out',
        animation: isVisible ? 'floatBg 6s ease-in-out infinite' : 'none',
        zIndex: 0
      }} />
      
      <div style={{
        position: 'absolute',
        top: '70%',
        right: '8%',
        width: '40px',
        height: '40px',
        backgroundColor: primary,
        borderRadius: '50%',
        opacity: isVisible ? 0.1 : 0,
        transition: 'opacity 1s ease-in-out 1s',
        animation: isVisible ? 'floatBg 6s ease-in-out infinite 1s' : 'none',
        zIndex: 0
      }} />
      
      <div style={{
        position: 'absolute',
        top: '60%',
        left: '15%',
        width: '30px',
        height: '30px',
        backgroundColor: primary,
        borderRadius: '50%',
        opacity: isVisible ? 0.1 : 0,
        transition: 'opacity 1s ease-in-out 2s',
        animation: isVisible ? 'floatBg 6s ease-in-out infinite 2s' : 'none',
        zIndex: 0
      }} />
    </>
  );
};

export default BackgroundElements;